import React from 'react';
import { Card } from '~/components/Card';
import { ServicesContext } from '~/services';
import { LeadingReachIntegration } from './LeadingReachIntegration';
import { OHIDIntegration } from './OHIDIntegration';

export function Integrations() {
    const services = React.useContext(ServicesContext);
    return (
        <Card
            className="mt-3"
            title={
                <div className="row mb-0">
                    <div className="col-8 align-self-center">Integrations</div>
                </div>
            }
        >
            <LeadingReachIntegration />
            {services.user.hasFeatureToggle('one_healthcare_id') && <OHIDIntegration />}
        </Card>
    );
}
